import ModalUserFormModule from './containers/modalUserFormModule'

export {default as ModalUserFormModuleLayout} from './components/modalUserFormModuleLayout'

export default ModalUserFormModule
